<template>
  <div class="sidebar">
    <div class="sidebartop">
      <router-link to="/">
        <div class="logoholder">
          <div class="logoReplace">CDT</div>
          <!-- <img class="logo" src="../../assets/sidebar/cdt-logo-orange.png" alt="cad-tekenaar.com logo" /> -->
        </div>
      </router-link>

      <div class="navmenu-wrapper">
        <router-link to="/kaart">
          <div class="navitem" :class="[currentPage.includes('/kaart') ? activeClass : 'activeClass', 'nav-item']">
            <img class src="../../assets/sidebar/tekenaarskaart-ico.png" />
          </div>
        </router-link>
        <router-link to="/tekenaars">
          <div class="navitem" :class="[currentPage === '/tekenaars' ? activeClass : 'activeClass', 'nav-item']">
            <img class src="../../assets/sidebar/tekenaars-ico.svg" alt="cad-tekenaar.com logo" />
          </div>
        </router-link>
        <router-link to="/opdrachten">
          <div class="navitem" :class="[currentPage.includes('/opdrachten') ? activeClass : 'activeClass', 'nav-item']">
            <img class src="../../assets/sidebar/opdrachten-ico.svg" alt="cad-tekenaar.com logo" />
          </div>
        </router-link>
        <router-link to="/tools">
          <div class="navitem" :class="[currentPage == '/tools' ? activeClass : 'activeClass', 'nav-item']">
            <img class style="max-width:29px;" src="../../assets/sidebar/links-ico.png" alt="cad-tekenaar.com logo" />
          </div>
        </router-link>
        <div class="button">
          <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="signal-stream" class="svg-inline--fa fa-signal-stream" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path
              fill="currentColor"
              d="M288 192c-35.38 0-64 28.62-64 63.1s28.62 63.1 64 63.1s64-28.62 64-63.1S323.4 192 288 192zM288 288c-17.62 0-32-14.37-32-31.1s14.38-31.1 32-31.1s32 14.37 32 31.1S305.6 288 288 288zM32 256c0-62.19 24.17-120.7 68.05-164.7C106.3 85.04 106.3 74.92 100 68.67c-6.25-6.187-16.38-6.219-22.62 .0625C27.48 118.8 0 185.3 0 256s27.48 137.2 77.39 187.3C80.52 446.4 84.61 448 88.72 448c4.078 0 8.172-1.562 11.3-4.656c6.25-6.25 6.281-16.37 .0313-22.62C56.17 376.7 32 318.2 32 256zM498.6 68.73c-6.25-6.312-16.38-6.281-22.62-.0625c-6.25 6.25-6.281 16.37-.0313 22.62C519.8 135.4 544 193.8 544 256s-24.17 120.7-68.05 164.7c-6.25 6.25-6.219 16.37 .0313 22.62C479.1 446.4 483.2 448 487.3 448c4.109 0 8.203-1.562 11.33-4.719C548.5 393.2 576 326.7 576 256S548.5 118.8 498.6 68.73zM167.5 132.4c-6.438-6.094-16.56-5.75-22.61 .625C113.4 166.4 96 210.1 96 256s17.36 89.62 48.88 122.1c3.141 3.312 7.375 4.1 11.62 4.1c3.938 0 7.891-1.437 10.98-4.375c6.422-6.062 6.719-16.19 .6406-22.62C142.3 329.6 128 293.8 128 256s14.25-73.62 40.13-100.1C174.2 148.6 173.9 138.4 167.5 132.4zM431.1 133c-6.062-6.375-16.16-6.719-22.61-.625c-6.422 6.062-6.719 16.19-.6406 22.62C433.8 182.4 448 218.3 448 256s-14.25 73.63-40.13 100.1c-6.078 6.437-5.781 16.56 .6406 22.62c3.094 2.937 7.047 4.375 10.98 4.375c4.25 0 8.484-1.687 11.62-4.1C462.6 345.6 480 301.9 480 256S462.6 166.4 431.1 133z"
            ></path>
          </svg>
        </div>
      </div>
    </div>

    <div class="sidebarbottom">
      <!--  -->

      <!-- <div class="links">
        <a href="https://cad-tekenaar.com" target="_blank">
          <div class="circle" style="background-color:#144b89;">
            <h3 style="font-weight:600;">CDT</h3>
          </div>
        </a>
        <a href="https://team.cad-tekenaar.com" target="_blank">
          <div class="circle" style="background-color:#999;">
            <h3 style="font-weight:600;">Team</h3>
          </div>
        </a>
        <a href="https://cad-tekena7950.activehosted.com/admin/" target="_blank">
          <div class="circle" style="background-color:#1c9ed9;">
            <h3 style="font-weight:600;">MB</h3>
          </div>
        </a>
      </div> -->
      <div :class="[currentPage === '/tekenaars-oud' ? activeClass : 'activeClass', 'nav-item']" class="navitem" @click="$router.push('tekenaars-oud')">
        <img style="opacity:.3;" src="../../assets/sidebar/tekenaars-ico.svg" alt="cad-tekenaar.com logo" />
      </div>

      <div class="navitem" @click="csvExportTekenaars">
        <img class="logitem" style="transform:translateX(3px)" src="../../assets/sidebar/export-ico.png" />
      </div>
      <div class="navitem" @click="setMessengerStatusFalse" v-if="status && status.messenger">
        <div class="messengerbolletje"></div>
        <img class="logitem messengerActive" src="../../assets/sidebar/messenger-ico.png" />
      </div>
      <div class="navitem" v-if="status && !status.messenger">
        <img class="logitem" style="opacity:.3;" src="../../assets/sidebar/messenger-ico.png" />
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import store from "@/store"
import { mapGetters } from "vuex"
// import user from "../../store/modules/user"

export default {
  data() {
    return {
      activeClass: "active",
      activeClassOrange: "activeOrange"
    }
  },
  computed: {
    ...mapGetters(["allTekenaars", "allOpdrachten"]),

    currentPage() {
      return this.$route.path
    },
    status() {
      return store.state.status
    },

    csvDataOpdrachten() {
      return this.allOpdrachten.map(item => ({
        id: item.id || "",
        opdrachtnummer: "CDT." + item.opdrachtnummerjaar + "." + item.opdrachtnummer || "",
        opdrachtgever: item.bedrijfsnaam || "",
        emailOpdrachtgever: item.email || "",
        telefoonnummerOpdrachtgever: item.telefoonnummer || "",
        contactpersoon: item.voornaam + " " + item.achternaam || "",
        status: item.status || "",
        // omschrijving: item.omschrijving || '',
        discipline: item.disciplines || "",
        werkplek: item.werkplek || "",
        tekenprogramma: item.tekenprogramma || "",
        gekoppeldeTekenaar: item.tekenaarsid || ""
        // intake: item.intake || ''
      }))
    },
    csvDataTekenaars() {
      return this.allTekenaars.map(item => ({
        id: item.id || "",
        voornaam: item.voornaam || "",
        achternaam: item.achternaam || "",
        naam: item.voornaam + " " + item.achternaam || "",
        disciplines: item.disciplines || ["geen disciplines..."],
        email: item.email || "",
        telefoonnummer: item.telefoonnummer || "",
        tekenprogramma: item.tekenprogramma || "",
        woonplaats: item.woonplaats || "",
        bedrijfsnaam: item.bedrijfsnaam || "",
        website: item.website || "",
        opleiding: item.opleiding || "",
        kvknummer: item.kvknummer || "",
        werkgebied: item.werkgebied || "",
        adres: item.adres || ""
      }))
    }
  },
  methods: {
    setMessengerStatusFalse() {
      if (confirm("Zet notificatie op 'gelezen'?")) {
        store.dispatch("setMessengerStatusFalse")
        if (confirm("wil je direct Mailblue openen?")) {
          var win = window.open("https://cad-tekena7950.activehosted.com/app/contacts?listid=21", "_blank")
          win.focus()
        }
      }
    },

    csvExport(arrData) {
      let csvContent = "data:text/csv;charset=utf-8,"
      csvContent += [Object.keys(arrData[0]).join(";"), ...arrData.map(item => Object.values(item).join(";"))].join("\n").replace(/(^\[)|(\]$)/gm, "")

      const data = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", data)
      link.setAttribute("download", `CDT_export_tekenaars-${new Date().toLocaleString()}.csv`)
      link.click()
    },
    csvExportTekenaars() {
      /**
       * This is a csv export of the new user profiles.
       */

      const { userAccounts } = this.$store.state

      const formatUserAccount = user => {
        const { userProfile } = user

        return {
          id: user.id || "",
          userType: user.userType || "",
          accountVersion: user.accountVersion || "",
          createdAt: user.createdAt?.toDate().toLocaleString() || "",
          lastUpdate: user.lastUpdate?.toDate().toLocaleString() || "",
          previousLogin: user.previousLogin?.toDate().toLocaleString() || "",
          email: userProfile.email || "",
          // userprofile
          beschikbaar: userProfile.beschikbaar || "",
          telefoon: userProfile.telefoon || "",
          voornaam: userProfile.voornaam || "",
          achternaam: userProfile.achternaam || "",
          geboortedatum: userProfile.geboortedatum || "",
          bedrijfsnaam: userProfile.bedrijfsnaam || "",

          hoogstGenotenOpleiding: userProfile.hoogstGenotenOpleiding || "",

          beschikbaarheidInUrenPerWeek: userProfile.beschikbaarheidInUrenPerWeek || "",
          postcode: userProfile.postcode || "",
          woonplaats: userProfile.plaats || "",
          straat: userProfile.straat || "",
          huisnummer: userProfile.huisnummer || "",
          werkgebied: userProfile.werkgebied || "",
          openVoorParticulierWerk: userProfile.openVoorParticulierWerk || "",
          berekeningen: userProfile.berekeningen || "",
          nen2580Werkzaamheden: userProfile.nen2580Werkzaamheden || "",
          aanvullendeApplicaties: userProfile.aanvullendeApplicaties || "",
          disciplines: userProfile.disciplines || "",
          tekenprogrammas: userProfile.tekenprogrammas || "",
          aantalJaarErvaring: userProfile.aantalJaarErvaring || "",
          iban: userProfile.iban || "",
          kvknummer: userProfile.kvknummer || "",
          btwnummer: userProfile.btwnummer || "",
          werkplek: userProfile.werkplek || "",
          aantalJaarZelfstandig: userProfile.aantalJaarZelfstandig || "",

          voorkeurTypeOpdrachten: userProfile.voorkeurTypeOpdrachten || "",
          kwaliteiten: userProfile.kwaliteiten || "",
          ambities: userProfile.ambities?.replace(/(\r\n|\n|\r)/gm, "") || ""
        }
      }

      const usersFormattedForCsv = userAccounts.map(e => formatUserAccount(e))

      return this.csvExport(usersFormattedForCsv)

      // return this.csvExport(this.csvDataTekenaars)

      // this.$modal.show("dialog", {
      //   title: "Backup / Export",
      //   text: "Maak een data-dump van je gegevens",
      //   buttons: [
      //     {
      //       title: "Tekenaars",
      //       handler: () => {
      //         this.csvExport(this.csvDataTekenaars)
      //       }
      //     },
      //     {
      //       title: "Opdrachten",
      //       default: true,
      //       handler: () => {
      //         this.csvExport(this.csvDataOpdrachten)
      //       }
      //     }
      //   ]
      // })
      // this.csvExport(this.allTekenaars);
    }
  }
}
</script>

<style lang="sass">
.button
  color: white
  display: flex
  align-items: center
  justify-content: center
  padding: 2rem 1rem
  cursor: pointer
  transition: .3s
  &:hover
    svg
      transform: scale(0.85)
  &:active
    svg
      transform: none

  svg
    transition: .3s
    height: 1.8rem
</style>

<style scoped>
.logoReplace {
  width: 50px;
  height: 50px;
  font-size: 18px;
  color: #ff9326;
  border-radius: 100%;
  border: 2px solid #ff9326;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

/* Ipad version */
/* ipad Mini Portrait */
@media only screen and (max-width: 1024px) {
  .sidebarbottom {
    display: none;
  }
}

.links {
  padding-left: 14px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15px;
}
a {
  text-decoration: none !important;
}
.circle {
  background-color: none;
  text-decoration: none;
  display: flex;
  width: 34px;
  height: 34px;
  font-size: 8px;
  font-weight: 600;
  margin-bottom: 30px;
  border: 1.5px solid white;
  cursor: pointer;
  color: white;
  align-items: center;
  justify-content: center;
  /* filter: grayscale(); */
  opacity: 0.4;
  background-color: rgb(00, 00, 00, 0) !important;
}
.circle:hover {
  filter: none;
  opacity: 1;
}
a .circles h3 {
  display: inline;
}

.sidebar {
  z-index: 3;
  height: 100%;
  max-height: 100%;
  position: fixed;
  top: 0;
  min-width: 100px;
  /* height: 100vh; */
  background-color: #0b1126;
  color: fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
}

.sidebarbottom .navitem {
  padding: 15px 37px;
  border-bottom: 0;
}

.sidebarbottom .navitem .logitem {
  max-width: 30px;
}

.navitem {
  display: flex;
  padding: 30px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #354053;
  max-width: 100px;
  position: relative;
}

.messengerActive {
  opacity: 1 !important;
}

/** sidebar icons on active */
.active {
  background-color: #3076ea;
}

.activeOrange {
  background-color: #ff9326;
}

.logitem {
  max-width: 35px;
  opacity: 0.3;
  cursor: pointer;
  transition: 0.2s;
}
.logitem:hover {
  opacity: 1;
}

.messengerbolletje {
  width: 12px;
  height: 12px;
  background-color: red;
  position: absolute;
  top: 30px;
  right: 30px;
  border-radius: 100px;
}

/** sidebar logo holder */
.logoholder {
  display: flex;
  padding: 30px 0;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #354053;
}
.logo {
  width: 50px;
  height: 50px;
}

@media screen and (max-width: 663px) {
  /* For mobile */
  .logoholder {
    display: none;
  }
  .sidebar {
    width: 100%;
    position: fixed;
    height: 70px;
    bottom: 0px;
  }
  .navmenu-wrapper {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
  }
}
</style>
